// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.total-works .button-container {
  display: flex;
  justify-content: center;
  padding-top: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/kit/scenes/RightsholderScene/RightsholderDashboard/DashboardWorksKpiCard/index.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,uBAAA;EACA,iBAAA;AAAJ","sourcesContent":[".total-works {\n  .button-container {\n    display: flex;\n    justify-content: center;\n    padding-top: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
